<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('eos.index')">
        Data Akhir Studi
      </Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ eosRecord.mahasiswa.name }}
    </h1>
    <div class="overflow-hidden w-full bg-white rounded-md shadow md:w-4/5">
      <form @submit.prevent="submit">
        <div class="flex flex-wrap px-8 py-4 justify-between">
          <text-input
            :value="formatDate(eosRecord.trn_date)"
            class="pb-4 md:pr-6 w-full md:w-1/4"
            input-class="text-center font-bold"
            label="Tanggal Input"
            disabled />
          <span class="font-bold text-lg">Jenjang Pendidikan: {{ eosRecord.jenjang_pendidikan }}</span>
        </div>
        <div class="flex flex-wrap px-8">
          <text-input
            v-model="form.validation_doc_num"
            :error="form.errors.validation_doc_num"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            label="Nomor Lembar Pengesahan"
            :disabled="isInputDisabled" />
          <file-input
            v-model="form.validation_doc_file"
            :error="form.errors.validation_doc_file"
            @preview="showModal('validation_doc_file')"
            :disabled="isInputDisabled"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="File lembar pengesahan" />
          <text-input
            v-model="form.diploma_serial_num"
            :error="form.errors.diploma_serial_num"
            :disabled="isInputDisabled"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            label="Nomor Ijazah" />
          <file-input
            v-model="form.diploma_file"
            :error="form.errors.diploma_file"
            :disabled="isInputDisabled"
            @preview="showModal('diploma_file')"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="File Ijazah" />
          <div class="w-full md:w-1/2" />
          <file-input
            v-model="form.academic_transcript_file"
            :error="form.errors.academic_transcript_file"
            :disabled="isInputDisabled"
            @preview="showModal('academic_transcript_file')"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="File Transkrip nilai" />
        </div>
        <div class="divider" />
        <div class="flex flex-wrap px-8">
          <file-input
            :value="eosRecord.student_id_file"
            @preview="showModal('student_id_file')"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="NIM"
            disabled />
          <file-input
            :value="eosRecord.nik_file"
            @preview="showModal('nik_file')"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="KTP"
            disabled />
          <file-input
            :value="eosRecord.father_nik_file"
            @preview="showModal('father_nik_file')"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="KTP Ayah"
            disabled />
          <file-input
            :value="eosRecord.mother_nik_file"
            @preview="showModal('mother_nik_file')"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="KTP Ibu"
            disabled />
          <file-input
            :value="eosRecord.no_kk_file"
            @preview="showModal('no_kk_file')"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="Kartu Keluarga"
            disabled />
        </div>
        <div class="flex px-8 pb-4 justify-end">
          <loading-button
            :loading="form.processing"
            v-if="!isInputDisabled"
            class="btn-indigo"
            type="submit">
            Simpan
          </loading-button>
        </div>
      </form>
    </div>
    <modal :is-modal-show="isModalVisible" @close="closeModal">
      <template slot="header">
        {{ modalTextHeader }}
      </template>
      <template slot="body">
        <div class="flex justify-center">
          <blob-image :src="imgUrl" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import BlobImage from '@/Shared/BlobImage'
import { Link, useForm } from '@inertiajs/vue2'
import { format, parseISO } from 'date-fns'

export default {
  metaInfo () {
    return {
      title: 'Input Akhir Studi',
    }
  },
  layout: Layout,
  components: {
    Link,
    TextInput,
    FileInput,
    Modal,
    BlobImage,
    LoadingButton,
  },
  props: {
    eosRecord: Object,
    currGraduationYear: Number,
    isInputEosClosed: Boolean,
  },
  data () {
    return {
      imgUrl: null,
      isModalVisible: false,
      modalTextHeader: 'Hasil Scan',
      form: useForm({
        _method: 'put',
        validation_doc_num: this.eosRecord.validation_doc_num,
        diploma_serial_num: this.eosRecord.diploma_serial_num,
        validation_doc_file: this.eosRecord.validation_doc_file,
        diploma_file: this.eosRecord.diploma_file,
        academic_transcript_file: this.eosRecord.academic_transcript_file,
      }),
    }
  },
  computed: {
    isInputDisabled () {
      return (
        this.eosRecord.approval_status_payment_id === 4 ||
        this.eosRecord.approval_status_payment_id === 5 ||
        this.isInputEosClosed
      )
    },
  },
  methods: {
    formatDate (date) {
      if (!date) return 'N/A'
      return format(parseISO(date), 'd MMM yyyy')
    },
    submit () {
      if (typeof this.form.validation_doc_file === 'string')
        this.form.validation_doc_file = null
      if (typeof this.form.diploma_file === 'string')
        this.form.diploma_file = null
      if (typeof this.form.academic_transcript_file === 'string')
        this.form.academic_transcript_file = null

      this.form.post(this.route('eos.update', this.eosRecord.id), {
        onSuccess: () => {
          this.form.validation_doc_file = this.eosRecord.validation_doc_file
          this.form.diploma_file = this.eosRecord.diploma_file
          this.form.academic_transcript_file =
            this.eosRecord.academic_transcript_file
        },
        preserveScroll: true,
      })
    },
    showModal (docType) {
      this.imgUrl = `/preview/${this.eosRecord[docType]}`
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
  },
}
</script>
